<img [src]="'assets/icons/' + icon + '.svg'" alt="icon + ' icon'" class="icon" />
